import React from "react";
import styled, { css } from "styled-components";
import { fontSize } from "../common/styled-mixins";
import Gettext from "../common/Gettext";
import Money from "../Money";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 163px;
  min-height: ${({ isCardButton }) => (isCardButton ? "40px" : "37px")};
  font-size: ${fontSize(12)};
  font-weight: 900;
  line-height: 16px;
  background-color: transparent;
  border: 2px solid #fff;
  border-radius: 19px;
  cursor: pointer;

  ${({ forBell }) =>
    !forBell &&
    css`
      :hover {
        background-color: #fff;
        color: #3b9478;

        > div {
          color: #3b9478;
        }
      }
    `};

  ${({ forBell }) =>
    forBell &&
    css`
      position: relative;
      background-image: linear-gradient(to left, #47c0c8 0%, #5c6cc0 100%);
      z-index: 2;

      ::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: block;
        background-image: linear-gradient(to left, #5c6cc0 0%, #47c0c8 100%);
        border-radius: inherit;
        z-index: -1;
        opacity: 0;
        transition: opacity 0.5s;
      }

      :hover {
        ::before {
          opacity: 1;
        }
      }
    `};
`;

const JoinText = styled.div`
  color: #fff;
`;

const Cost = styled.div`
  color: #ffcc00;
`;

const DemoButton = props => {
  return (
    <Container
      onClick={props.onClick}
      isCardButton={props.isCardButton}
      forBell={props.forBell}
    >
      <JoinText>
        <Gettext>JOIN demo</Gettext>
      </JoinText>
      <Cost>
        <Money>{props.participation_price}</Money>
      </Cost>
    </Container>
  );
};

export default DemoButton;



// WEBPACK FOOTER //
// ./src/components/Buttons/DemoTournamentButton.js